import * as React from "react";
import NavBar from "../components/NavBar";
import { RouteChildrenProps } from "react-router";
import { Modal, Pagination, Button, ButtonToolbar } from "react-bootstrap";
import "./WarrantyListPage.css";
import { firestore, storage } from "firebase";
import * as fs from "../firestore";
import {createWarrantyImageKey,  tryGetDownloadUrl} from "../storage";
import WarrantyTable, { Warranty } from "../components/WarrantyTable";
import AppUser from "../AppUser";
import firebase from "../firebase";

const storageRef = storage().ref();
const usersRef = firestore().collection(fs.Collection.Users);
const WarrantyRef = firestore().collection(fs.Collection.Warranties);
const PAGINATION_LIMIT = 20;

interface Props extends RouteChildrenProps {
    user: AppUser
}

interface State {
    selectedWarrantyId: string;
    showModal: boolean;
    startMake: boolean;
    nowMaking: boolean;
    makeWarranty: boolean;
    Warranty: Warranty[];
}

export default abstract class WarrantyListPage extends React.Component<Props, State> {
     private onClickMakeWarrantyBound: (id: string) => void;
     private onClickCloseBound: () => void;
     private onClickMakingWarrantyBound: () => void;

    constructor(props: Props) {
        super(props);
        this.onClickMakeWarrantyBound = this.onClickMakeWarranty.bind(this);
        this.onClickCloseBound = this.onClickClose.bind(this);
        this.onClickMakingWarrantyBound = this.onClickMakingWarranty.bind(this);

        this.state = {
            selectedWarrantyId: "",
            showModal: false,
            startMake: false,
            nowMaking: false,
            makeWarranty: false,
            Warranty: []
        };
    }

    abstract getPageTitle(): string;
    abstract makeFetchWarrantyQuery(limit: number, startAfter: Warranty|null, reverseOrder: boolean): firestore.Query;

    async componentDidMount() {
        const Warranty = await this.fetchWarranty();
        this.setState({
            Warranty
        });
    }

    async onClickClose() {
        if ( this.state.makeWarranty ) {
            const Warranty = await this.fetchWarranty();
            this.setState({
                showModal: false,
                makeWarranty: false,
                Warranty
           })
        }
        else {
            this.setState({
                showModal: false,
                makeWarranty: false
           })
        }
    } 

    async onClickMakeWarranty(id: string) {
        this.setState({
            selectedWarrantyId: id,
            showModal: true,
            startMake: true
        })
    }

    async onClickMakingWarranty() {
        var makeStat = true;
        this.setState({
            nowMaking: true,
            startMake: false
        })
        const createWarrantyPDF = firebase.functions().httpsCallable('createWarrantyPDF');
        await createWarrantyPDF({
            refID: this.state.selectedWarrantyId,
        })
        .then(function(result) {
            makeStat = true;
        })
        .catch(function(err) {
            makeStat = false;
        });
        this.setState({
            nowMaking: false,
            makeWarranty: makeStat
        })
    }

    private async createUserIdNameMap(userIds: string[]): Promise<{[userId: string]: string}> {
        const result: {[userId: string]: string} = {};
        const userNames = await Promise.all(userIds.map(async id => {
            const user = (await firestore().collection(fs.Collection.Users).doc(id).get()).data() as fs.User;
            return user.name;
        }));
        userIds.forEach((id, index) => {
            result[id] = userNames[index];
        });
        return result;
    }

    private async fetchWarranty(startAfter: Warranty|null = null, reverseOrder: boolean = false): Promise<Warranty[]> {
        const query = this.makeFetchWarrantyQuery(PAGINATION_LIMIT, startAfter, reverseOrder);
        const userIdSet = new Set<string>();
        const rawWarranty = (await query.get()).docs.map(doc => {
            const data = doc.data() as fs.Warranty;
            userIdSet.add(data.userRef.id);
            return {id: doc.id, data};
        });
        const userIdNameMap = await this.createUserIdNameMap(Array.from(userIdSet));
        return rawWarranty.map(rawWarranty => {
            return {
                id: rawWarranty.id,
                userName: userIdNameMap[rawWarranty.data.userRef.id],
                ...rawWarranty.data
            };
        });
    }

    render() {
        return (
            <div>
                <NavBar {...this.props} />
                <div className="warranty_list">
                    <h2 className="warranty_title">{this.getPageTitle()}</h2>
                    <WarrantyTable
                        Warranty={this.state.Warranty}
                        onImageLinkClicked={async (id, filename) => {
                            const url = await tryGetDownloadUrl(storageRef, createWarrantyImageKey(id, filename));
console.log(url);
                            if (!url) {
                                alert("ファイルが見つかりません");
                                return;
                            }
                            window.open(url, "_blank");
                        }}
                        onClickMakeWarranty={this.onClickMakeWarrantyBound}
                    />
                </div>
                <Modal
                    show={this.state.showModal}
                    onHide={() => this.setState({showModal: false})}
                    dialogClassName="modal-40w"
                    aria-labelledby="example-custom-modal-styling-title"
                >
                    <Modal.Header>
                        <Modal.Title id="example-custom-modal-styling-title">
                            {"保証書作成"}
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        {
                            this.state.startMake ?
                                <p><a href="#" onClick={this.onClickMakingWarrantyBound}>{"保証書作成開始"}</a></p> :
                                this.state.nowMaking ? "保証書作成中" :
                                this.state.makeWarranty ? "保証書が作成できました" : "保証書が作成できませんでした。しばらく待ってから再実行ください"
                        }
                    </Modal.Body>
                    <Modal.Footer>
                        {
                        this.state.nowMaking ? null :
                            <ButtonToolbar>
                                <Button variant="primary" type="button" onClick={this.onClickCloseBound}>閉じる</Button>
                            </ButtonToolbar>
                        }
                    </Modal.Footer>
                </Modal>
            </div>
        );
    }
}

